//@vendor
const { createActions } = require('redux-actions');
const get = require('lodash/object/get');

const {
    loanPurposes,
    VERSION_2,
    payrollLoanCommon,
    contractEasyLoan: {
        PAYMENT_DAY_END_OF_MONTH,
        PRODUCT_TYPE,
    },
    amortizationTypes,
} = require('../../loansConstants/index');
const apiURLBuilder = require('core/apiURLBuilder');
const DateHelper = require('utilities/dateHelper');
const { es: { DATE_FORMAT_WITH_SLASHES } } = require('commonsConstants/dateFormatTypes');

//@utilities
const { APIGet, APIPost } = require('utilities/APIRequestHelper');
const { formatAmount } = require('utilities/currencyHelper');
const { EURO_TEXT, EASY_LOAN_MAILTYPE } = require('constants/index');

//@helpers
const simpleActions = createActions(
    'SET_INIT_API_FLAG',

    'CONTRACT_EASY_LOAN_GET_INIT_PROPOSITION',
    'CONTRACT_EASY_LOAN_GET_PROPOSITION_SUCCESS',
    'CONTRACT_EASY_LOAN_INIT_ONE_SUCCESS',
    'CONTRACT_EASY_LOAN_INIT_LOADING',
    'CONTRACT_EASY_LOAN_INIT_ERROR',

    'GET_EASY_LOAN_INIT_INE_DOCUMENT',
    'GET_EASY_LOAN_INIT_INE_DOCUMENT_SUCCESS',
    'GET_EASY_LOAN_INIT_INE_DOCUMENT_ERROR',

    'GET_EASY_LOAN_INE_DOCUMENT',
    'GET_EASY_LOAN_INE_DOCUMENT_ERROR',
    'GET_EASY_LOAN_INIT_INE_DOCUMENT_SUCCESS',
    'GET_EASY_LOAN_INIT_POLICY_DOCUMENT',
    'GET_EASY_LOAN_INIT_POLICY_DOCUMENT_SUCCESS',


    'GET_EASY_LOAN_INIT_POLICY_DOCUMENT_ERROR',

    'CONTRACT_EASY_LOAN_INIT_DOWNLOAD_PRINT_DOCUMENT_SUCCESS',
    'CONTRACT_EASY_LOAN_INIT_DOWNLOAD_PRINT_DOCUMENT_ERROR',
    'CONTRACT_EASY_LOAN_INIT_GET_PROPOSITION_ERROR',

    'CONTRACT_EASY_LOAN_PRE_FILL',
    'CONTRACT_EASY_LOAN_PRE_FILL_ERROR',
    'CONTRACT_EASY_LOAN_PRE_FILL_SUCCESS',
    'GET_EASY_LOAN_EXPEDIENT_SUCCESS',
    'CONTRACT_EASY_LOAN_RESET_EXPEDIENT',
    'CONTRACT_EASY_LOAN_INIT_WILL_LEAVE',

);

const setInitApiFlag = (initAPIFlag, mailAPIFlag, checkboxFlag, btnFlag) => dispatch => {
    dispatch(simpleActions.setInitApiFlag({ initAPIFlag, mailAPIFlag, checkboxFlag, btnFlag }))
}
const getInitPropositionNumber = (response) => (dispatch, getState) => {
    const propositionNumber = get(response, 'propuesta.numerodepropuesta');
    const propositionYear = get(response, 'propuesta.anio');
    const contractNumber = get(response, 'contrato.numerodecontrato');
    dispatch(simpleActions.contractEasyLoanGetInitProposition());
    const easyLoanTypecIExpedient = getState().contractInit.get('easyLoanTypecIExpedient');

    return dispatch(getInitRemainingInfo(propositionNumber, propositionYear)).then(remain => {
        const { amortizationReponse, initialDataResponse } = remain;
        dispatch(
            simpleActions.contractEasyLoanGetPropositionSuccess({
                response: {
                    propositionNumber,
                    propositionYear,
                    contractNumber,
                    lackDate: initialDataResponse.fechaFinCarencia,
                    loanDueDate: initialDataResponse.fechaVctoPrestamos,
                    chargeOffDate: amortizationReponse.fechaAmortiz,
                    chargeOffAnniversaryDate: get(amortizationReponse, 'listaFechasAmortiz.fechaAmortiz.0.fechaAmortiz1')
                }
            })
        );
        !easyLoanTypecIExpedient && dispatch(getInitINEContract());
    })
};

const getInitPropositionNumberPolicy = (newParam) => (dispatch, getState) => {
    const immContractEasyLoan = getState().contractEasyLoanTypeC;

    if (immContractEasyLoan.get('fetchingProposition')) {
        return;
    }
    const paymentDaySelected = immContractEasyLoan.get('paymentDaySelected');
    const productInfo = getProductInfo(paymentDaySelected, immContractEasyLoan);

    let propositionNumber, propositionYear, contractNumber;

    const params = {
        query: {
            importePpta: {
                importe: immContractEasyLoan.get('selectedAmount'),
                divisa: immContractEasyLoan.get('currency')
            },
            plazoPpta: {
                numerodeunidades: immContractEasyLoan.get('selectedTerm'),
                unidaddetiempo: 'M'
            },
            finalidadPpta: '99',
            tipoPreciosOpera: 'E',
            canalOperacion: 'RED',
            estandar: {
                codigodeestandar: productInfo.standard,
                subtipodeproducto: {
                    subtipodeproducto: productInfo.subtype,
                    tipodeproducto: {
                        tipodeproducto: productInfo.type
                    }
                }
            }
        }
    };

    dispatch(simpleActions.contractEasyLoanGetInitProposition());

    APIPost({ dispatch, endpoint: 'contractEasyLoanPropositionNumber', params })
        .then(response => {

            propositionNumber = get(response, 'propuesta.numerodepropuesta');
            propositionYear = get(response, 'propuesta.anio');
            contractNumber = get(response, 'contrato.numerodecontrato');

            return dispatch(getInitRemainingInfo(propositionNumber, propositionYear));
        })
        .then(response => {
            const { amortizationReponse, initialDataResponse } = response;

            return dispatch(
                simpleActions.contractEasyLoanGetPropositionSuccess({
                    response: {
                        propositionNumber,
                        propositionYear,
                        contractNumber,
                        lackDate: initialDataResponse.fechaFinCarencia,
                        loanDueDate: initialDataResponse.fechaVctoPrestamos,
                        chargeOffDate: amortizationReponse.fechaAmortiz,
                        chargeOffAnniversaryDate: get(amortizationReponse, 'listaFechasAmortiz.fechaAmortiz.0.fechaAmortiz1')
                    }
                })
            );
        })
        .then(() => {
            dispatch(getInitPolicyContract(newParam));
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.contractEasyLoanInitGetPropositionError({ error: response.error }));
            } else {
                throw response;
            }
        });
};
const getProductInfo = (paymentDaySelected, immContractEasyLoanTypec) => {
    let type, subtype, standard, indCapson, indIntccp;

    if (paymentDaySelected === PAYMENT_DAY_END_OF_MONTH) {
        standard = immContractEasyLoanTypec.get('standard');
        subtype = immContractEasyLoanTypec.get('subtype');
        type = immContractEasyLoanTypec.get('type');
    } else {
        standard = immContractEasyLoanTypec.get('aniversaryStandard');
        subtype = immContractEasyLoanTypec.get('aniversarySubtype');
        type = immContractEasyLoanTypec.get('aniversaryType');
        indCapson = 'N';
        indIntccp = 'N';
    }

    return {
        standard,
        type,
        subtype,
        indCapson,
        indIntccp
    }
}
const getInitRemainingInfo = (propositionNumber, propositionYear) => dispatch => {
    const params = {
        query: {
            anio: propositionYear,
            numeroPropuesta: propositionNumber
        }
    };

    const promises = [];

    const amortizationPromise = APIGet({
        dispatch,
        params,
        endpoint: 'contractEasyLoanAmortizationAmortization'
    });
    promises.push(amortizationPromise);

    const initialDataPromise = APIGet({
        dispatch,
        params,
        endpoint: 'contractEasyLoanInitialData'
    });
    promises.push(initialDataPromise);

    return Promise.all(promises).then(responses => ({
        amortizationReponse: responses[0],
        initialDataResponse: responses[1]
    }));
};

const getLoanInitPolicyContractDocuments = () => (dispatch, getState) => {
    const immContractEasyLoan = getState().contractEasyLoan;
    const operationProcessId = immContractEasyLoan.get('operationProcessIdPolicy');
    dispatch(simpleActions.getEasyLoanInitPolicyDocument());
    if (operationProcessId && EASY_LOAN_MAILTYPE.CONTRACTUAL) {
        APIGet(dispatch, `${apiURLBuilder.getURL('loanContractDocuments')}/${operationProcessId}/${EASY_LOAN_MAILTYPE.CONTRACTUAL}/documents`)
            .then(response => {
                const { base64Document, temporaryDocumentId } = response;
                dispatch(simpleActions.getEasyLoanInitPolicyDocumentSuccess({ base64: base64Document, documentId: temporaryDocumentId }));

            })
            .catch(() => {

                dispatch(simpleActions.getEasyLoanInitPolicyDocumentError());
            });
    }
}
const getLoanInitINEContractDocuments = (easyLoanMailType) => (dispatch, getState) => {
    const immContractEasyLoan = getState().contractEasyLoan;
    const immEasyLoanTypeC = getState().loanRecordStatus;
    const operationProcessId = immContractEasyLoan.get('operationProcessIdINE')
    const recordId = immEasyLoanTypeC.get('recordId')
    dispatch(simpleActions.getEasyLoanIneDocument())
    if (operationProcessId && easyLoanMailType === EASY_LOAN_MAILTYPE.CONTRACTUAL) {

        const params = {
            header: {
                version: 2
            }
        };
        APIGet(dispatch, `${apiURLBuilder.getURL('getEasyLoanINEDocument')}/${EASY_LOAN_MAILTYPE.PRECONTRACTUAL}/${recordId}`, params)
            .then(response => {
                const { base64Document, temporaryDocumentId } = response;
                const operationProcessId = response.operationProcessId
                dispatch(simpleActions.getEasyLoanInitIneDocumentSuccess({ base64: base64Document, documentId: temporaryDocumentId }))

                return { response, operationProcessId }

            })
            .then(({ response, operationProcessId }) => {
                APIGet(dispatch, `${apiURLBuilder.getURL('loanContractDocuments')}/${response.operationProcessId}/${EASY_LOAN_MAILTYPE.PRECONTRACTUAL}/documents`)
                    .then(response => {
                        const { base64Document, temporaryDocumentId } = response;
                        dispatch(simpleActions.getEasyLoanInitIneDocumentSuccess({ base64: base64Document, documentId: temporaryDocumentId, operationProcessId }));
                    })
                    .catch(() => {
                        dispatch(simpleActions.getEasyLoanInitIneDocumentError());
                    });
            })
            .catch(() => {
                dispatch(simpleActions.getEasyLoanIneDocumentError())
            });
    }
    else {
        const operationProcessId = immContractEasyLoan.get('operationProcessIdINE')
        APIGet(dispatch, `${apiURLBuilder.getURL('loanContractDocuments')}/${operationProcessId}/${EASY_LOAN_MAILTYPE.PRECONTRACTUAL}/documents`)
            .then(response => {
                const { base64Document, temporaryDocumentId } = response;
                dispatch(simpleActions.getEasyLoanInitIneDocumentSuccess({ base64: base64Document, documentId: temporaryDocumentId, operationProcessId }));
            })
            .catch(() => {
                dispatch(simpleActions.getEasyLoanInitIneDocumentError());
            });
    }
}
const getLoanInitINEContractDocumentsPreaproved = () => (dispatch, getState) => {
    const immEasyLoanTypeC = getState().loanRecordStatus;
    const recordId = immEasyLoanTypeC.get('recordId')
    dispatch(simpleActions.getEasyLoanIneDocument())

    const params = {
        header: {
            version: 2
        }
    };
    return APIGet(dispatch, `${apiURLBuilder.getURL('getEasyLoanINEDocument')}/${EASY_LOAN_MAILTYPE.PRECONTRACTUAL}/${recordId}`, params)
        .then(response => {
            const { base64Document, temporaryDocumentId } = response;
            const operationProcessId = response.operationProcessId
            dispatch(simpleActions.getEasyLoanInitIneDocumentSuccess({ base64: base64Document, documentId: temporaryDocumentId, operationProcessId }))

            return { response, operationProcessId }

        })
        .then(({ response, operationProcessId }) => {
            return APIGet(dispatch, `${apiURLBuilder.getURL('loanContractDocuments')}/${response.operationProcessId}/${EASY_LOAN_MAILTYPE.PRECONTRACTUAL}/documents`)
                .then(response => {
                    const { base64Document, temporaryDocumentId } = response;
                    dispatch(simpleActions.getEasyLoanInitIneDocumentSuccess({ base64: base64Document, documentId: temporaryDocumentId, operationProcessId }));
                })
                .catch(() => {
                    dispatch(simpleActions.getEasyLoanInitIneDocumentError());
                });
        })
        .catch(() => {
            dispatch(simpleActions.getEasyLoanIneDocumentError())
        });

}
const getLoanInitContractDocumentsPolicy = () => (dispatch, getState) => {
    const immContractEasyLoan = getState().contractEasyLoan;
    const operationProcessId = immContractEasyLoan.get('operationProcessIdINE')
    dispatch(simpleActions.getEasyLoanInitPolicyDocument())

    APIGet(dispatch, `${apiURLBuilder.getURL('loanContractDocuments')}/${operationProcessId}/${EASY_LOAN_MAILTYPE.CONTRACTUAL}/documents`)
        .then(response => {
            const { base64Document, temporaryDocumentId } = response;

            dispatch(simpleActions.getEasyLoanInitPolicyDocumentSuccess({ base64: base64Document, documentId: temporaryDocumentId }));
        })
        .catch(() => {
            dispatch(simpleActions.getEasyLoanInitPolicyDocumentError());
        });

}

const getFindOutLoanInitINEContractDocuments = (easyLoanMailType) => (dispatch, getState) => {
    const recordId = getState().loanRecordStatus.get('recordId')
    dispatch(simpleActions.getEasyLoanIneDocument())
    if (recordId && easyLoanMailType === EASY_LOAN_MAILTYPE.PRECONTRACTUAL) {
        const params = {
            header: {
                version: 2
            }
        };
        APIGet(dispatch, `${apiURLBuilder.getURL('getEasyLoanINEDocument')}/${EASY_LOAN_MAILTYPE.PRECONTRACTUAL}/${recordId}`, params)
            .then(response => {
                const { base64Document, temporaryDocumentId, operationProcessId } = response;
                const operationProcessIdDocument = operationProcessId
                dispatch(simpleActions.getEasyLoanInitIneDocumentSuccess({ base64: base64Document, documentId: temporaryDocumentId, operationProcessId }))
                dispatch(simpleActions.getEasyLoanExpedientSuccess())
                return { response, operationProcessIdDocument }
            })
            .then(({ response, operationProcessIdDocument }) => {
                APIGet(dispatch, `${apiURLBuilder.getURL('loanContractDocuments')}/${response.operationProcessId}/${EASY_LOAN_MAILTYPE.PRECONTRACTUAL}/documents`)
                    .then(response => {
                        const { base64Document, temporaryDocumentId } = response;
                        dispatch(simpleActions.getEasyLoanInitIneDocumentSuccess({ base64: base64Document, documentId: temporaryDocumentId, operationProcessId: operationProcessIdDocument }));
                    })
                    .catch(() => {
                        dispatch(simpleActions.getEasyLoanInitIneDocumentError());
                    });
            })
            .catch(() => {
                dispatch(simpleActions.getEasyLoanIneDocumentError())
            });
    }

}
const getInitINEContract = (easyLoanMailType) => (dispatch) => {
    dispatch(simpleActions.contractEasyLoanInitLoading());
    const params = dispatch(getInitParams(1, easyLoanMailType));
    return APIPost({
        dispatch,
        endpoint: 'overdraftInit',
        params
    })

        .then((response) => {
            dispatch(simpleActions.contractEasyLoanInitOneSuccess({ operationProcessIdINE: response.operationProcessId }));
            easyLoanMailType === easyLoanMailType === EASY_LOAN_MAILTYPE.CONTRACTUAL && dispatch(getLoanInitPolicyContractDocuments())
            dispatch(getLoanInitINEContractDocuments(easyLoanMailType))
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.contractEasyLoanInitError());
            } else {
                throw response;
            }
        });
}
const getInitPolicyContract = (newParam) => (dispatch) => {

    dispatch(simpleActions.contractEasyLoanInitLoading());
    const params = dispatch(getInitParams(2, newParam));
    return APIPost({
        dispatch,
        endpoint: 'overdraftInit',
        params
    })
        .then((response) => {
            dispatch(simpleActions.contractEasyLoanInitOneSuccess({ operationProcessIdINE: response.operationProcessId }));
            dispatch(getLoanInitContractDocumentsPolicy())
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.contractEasyLoanInitError());
            } else {
                throw response;
            }
        });
}

const getInitParams = (initCall, newParam) => (dispatch, getState) => {
    const immContractEasyLoan = getState().contractEasyLoanTypeC;
    const immEasyLoanTypeC = getState().loanRecordStatus;
    const immContractInitEasyLoan = getState().contractInit;
    const operationProcessId = immContractInitEasyLoan.get('operationProcessId')
    const accounts = getState().accounts;
    const immAccount = accounts.getIn(['byId', immContractEasyLoan.get('selectedAccount'), 'iban']);
    const endOfMonth = immContractEasyLoan.get('paymentDaySelected') === PAYMENT_DAY_END_OF_MONTH;
    const financedCommission = immContractEasyLoan.get('indCapson') === amortizationTypes.YES ?
        payrollLoanCommon.FINANCIADA : payrollLoanCommon.NO_FINANCIADA;
    return {
        query:
        {
            account: immAccount || 0,
            amount: formatAmount(immContractEasyLoan.get('selectedAmount'), 'es'),
            calculatedOpeningCommission: formatAmount(immContractInitEasyLoan.getIn(['openingCommission', 'amount']), 'es'),
            capitalizedOpeningCommissionIndicator: immContractEasyLoan.get('indCapson'),
            contractNumberAccount: 0,
            dueDate: immContractInitEasyLoan.get('loanDueDate'),
            endOfMonth: endOfMonth,
            financedCommission: financedCommission,
            firstTime: true,
            loanPurpose: immContractEasyLoan.get('selectedPurpose'),
            processType: initCall === 1 ? EASY_LOAN_MAILTYPE.PRECONTRACTUAL : EASY_LOAN_MAILTYPE.CONTRACTUAL,
            product: {
                standard: immContractInitEasyLoan.get('standard'),
                subType: immContractInitEasyLoan.get('subtype'),
                type: immContractInitEasyLoan.get('type'),
            },
            productDuration: immContractEasyLoan.get('selectedTerm').toString(),
            productType: PRODUCT_TYPE,
            propositionContractNumber: immContractInitEasyLoan.get("contractNumber"),
            propositionNumber: immContractInitEasyLoan.get('propositionNumber'),
            tin: immContractInitEasyLoan.get('tin'),
            tae: formatAmount(immContractEasyLoan.get('tae'), 'es'),
            term: immContractEasyLoan.get('selectedTerm').toString(),
            year: immContractInitEasyLoan.get('propositionYear'),
            expedientId: immContractEasyLoan.get('recordId') || immEasyLoanTypeC.get('recordId'),
            ...(newParam && { attachedEvidences: [operationProcessId] })

        }
    }
}

const getEasyLoanInitINEDocument = () => (dispatch, getState) => {
    const immEasyLoanTypeC = getState().contractEasyLoanTypeC
    const immContractEasyLoan = getState().contractEasyLoan;
    const comisionApertura = immEasyLoanTypeC.getIn(['productoActivoSegmentado', 'comisionApertura']);
    const propositionYear = immContractEasyLoan.get('propositionYear');
    const propositionNumber = immContractEasyLoan.get('propositionNumber');
    const contractNumber = immContractEasyLoan.get('contractNumber');
    const fechaVenci = DateHelper.formatDate(immEasyLoanTypeC.get('fechaVenci'), DATE_FORMAT_WITH_SLASHES);

    const params = {
        header: {
            version: VERSION_2
        },
        query:
        {
            year: propositionYear,
            calculatedOpeningCommission: comisionApertura || 0,
            financedCommission: immEasyLoanTypeC.get('indCapson') === amortizationTypes.YES ? payrollLoanCommon.FINANCIADA : payrollLoanCommon.NO_FINANCIADA,
            productDuration: immEasyLoanTypeC.get('selectedTerm').toString(),
            dueDatgetEasyLoanTypecIneDocumentErrore: fechaVenci,
            endOfMonth: false,
            amount: formatAmount(immEasyLoanTypeC.get('selectedAmount'), 'es'),
            propositionContractNumber: contractNumber,
            propositionNumber: propositionNumber,
            firstTime: true, //fixed value. The user hasn't contracted the loan yet in this step. So we show a template.
            tae: formatAmount(immEasyLoanTypeC.get('tae'), 'es'),
            tin: formatAmount(immEasyLoanTypeC.get('tin'), 'es'),
            productType: PRODUCT_TYPE,
        }
    };

    dispatch(simpleActions.getEasyLoanInitIneDocument());

    APIPost({ dispatch, endpoint: 'contractEasyLoanINEDocumentV2', params }).then(response => {
        const { base64, documentId } = response;
        dispatch(simpleActions.getEasyLoanInitIneDocumentSuccess({ base64, documentId }));
    }).catch(() => {
        dispatch(simpleActions.getEasyLoanInitIneDocumentError());
    });
};
const preFillContractEasyLoan = (segmentedLoan) => (dispatch) => {
    let openingCommission = get(segmentedLoan, 'comisionApertura', 0);
    const importe = parseFloat(get(segmentedLoan, 'importeMaximo'));
    const termMin = get(segmentedLoan, 'plazoMinimo', 0);
    const termMax = get(segmentedLoan, 'plazoMaximo', 0);

    openingCommission = parseFloat(openingCommission.replace(',', '.'));

    const openingCommissionMinimum = parseFloat(get(segmentedLoan, 'comisionAperturaMin'));
    const openingCommissionAmount = importe * openingCommission / 100;

    const comisionApertura = openingCommissionAmount < openingCommissionMinimum ?
        openingCommissionMinimum : openingCommissionAmount;

    const promiseArray = [];
    const query = {
        indCapson: 'N',
        indIntccp: 'N',
        divisa: get(segmentedLoan, 'divisa', EURO_TEXT),
        importe,
        indicaPrecios: 'E', //fixed value
        tipodeproducto: get(segmentedLoan, 'tipoPagoAniversario', 0),
        subtipodeproducto: get(segmentedLoan, 'subtipoPagoAniversario', 0),
        codigodeestandar: get(segmentedLoan, 'erPagoAniversario', 0),
        comisionApertura
    };


    if (termMax > 0) {
        const queryMin = Object.assign({}, query, { plazo: termMax });
        promiseArray.push(APIGet({ dispatch, endpoint: 'contractEasyLoanInstallments', params: { query: queryMin } }));
    }

    if (termMin > 0) {
        const queryMax = Object.assign({}, query, { plazo: termMin });
        promiseArray.push(APIGet({ dispatch, endpoint: 'contractEasyLoanInstallments', params: { query: queryMax } }));
    }

    dispatch(simpleActions.contractEasyLoanPreFill());
    return Promise.all(promiseArray)
        .then(response => (Object.assign(segmentedLoan, {
            minTae: get(response, '0.tae', {}),
            maxTae: get(response, '1.tae', {})
        })))
        .then(response => dispatch(simpleActions.contractEasyLoanPreFillSuccess({ ...response })))
        .catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.contractEasyLoanPreFillError({ error: response.error }));
            } else {
                throw response;
            }
        });
};
const resetStepExpedient = () => (dispatch) => {
    dispatch(simpleActions.contractEasyLoanResetExpedient());
}
module.exports = {
    simpleActions,
    setInitApiFlag,
    getInitPropositionNumber,
    preFillContractEasyLoan,
    getFindOutLoanInitINEContractDocuments,
    getLoanInitINEContractDocuments,
    getInitPropositionNumberPolicy,
    resetStepExpedient,
    getLoanInitINEContractDocumentsPreaproved
};